import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

export async function fetchPrice(cuts, pro_code, transformers) {
  const { data } = await apiClient.post("/price", {
    cuts,
    pro_code: pro_code || null,
    transformers: transformers || 1,
  });
  return data;
}

export async function createCheckout(cuts, customer_email, pro_code, transformers) {
  const origin_url = window.location.origin;
  const { data } = await apiClient.post("/checkout/session", {
    cuts,
    origin_url,
    customer_email: customer_email || null,
    pro_code: pro_code || null,
    transformers: transformers || 1,
  });
  return data;
}

export async function buySample(customer_email) {
  const origin_url = window.location.origin;
  const { data } = await apiClient.post("/checkout/sample", {
    origin_url,
    customer_email: customer_email || null,
  });
  return data;
}

export async function getCheckoutStatus(sessionId) {
  const { data } = await apiClient.get(`/checkout/status/${sessionId}`);
  return data;
}

export async function submitQuote(payload) {
  const { data } = await apiClient.post("/quote", payload);
  return data;
}

// ---------- Admin ----------
const ADMIN_TOKEN_KEY = "sxg-admin-token";

export const adminToken = {
  get: () => localStorage.getItem(ADMIN_TOKEN_KEY),
  set: (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
};

const authHeader = () => {
  const t = adminToken.get();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export async function adminLogin(password) {
  const { data } = await apiClient.post("/admin/login", { password });
  adminToken.set(data.token);
  return data;
}

export async function adminLogout() {
  try { await apiClient.post("/admin/logout", {}, { headers: authHeader() }); } catch {}
  adminToken.clear();
}

export async function adminListOrders() {
  const { data } = await apiClient.get("/admin/orders", { headers: authHeader() });
  return data.orders || [];
}

export async function adminMarkShipped(sessionId, { tracking_number, carrier } = {}) {
  const { data } = await apiClient.post(
    `/admin/orders/${sessionId}/mark-shipped`,
    { tracking_number: tracking_number || null, carrier: carrier || null },
    { headers: authHeader() },
  );
  return data;
}

export async function adminUnmarkShipped(sessionId) {
  const { data } = await apiClient.post(
    `/admin/orders/${sessionId}/unmark-shipped`,
    {},
    { headers: authHeader() },
  );
  return data;
}

export async function adminBackfillShipping() {
  const { data } = await apiClient.post(
    "/admin/orders/backfill-shipping",
    {},
    { headers: authHeader(), timeout: 120000 },
  );
  return data;
}
